import { IInfrastructureObject } from './helpers';
import { InfrastructureType } from '../../../store/map';
import { IOSMCompanySchema } from '../../../types';
import { getInfrastructureIconLayout } from '../icons/infrastructure';
import { getBalloonLayout } from '../layouts/balloon';

export const convertInfrastructureToFeature = (
  ymaps: YMaps.IYMaps,
  item: IOSMCompanySchema,
  type: InfrastructureType,
): IInfrastructureObject => ({
  geometry: {
    coordinates: [item.coordinates?.lat ?? 0, item.coordinates?.lng ?? 0],
    type: 'Point',
  },
  id: String(item.id),
  infrastructureType: type,
  options: {
    balloonLayout: getBalloonLayout(ymaps),
    iconLayout: getInfrastructureIconLayout(ymaps, type),
    iconOffset: [-27, -61],
    iconShape: {
      coordinates: [27, 27],
      radius: 26.5,
      type: 'Circle',
    },
    iconSize: [54, 61],
    zIndex: 1,
  },
  properties: {
    objects: [
      {
        name: item.title ?? '',
        type,
      },
    ],
  },
  type: 'Feature',
});
